module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//group.png?v=b287bfba";